import React from 'react';

import { connect } from 'react-redux';
import { projectRouteTreeTooltipDataChanged } from '@Pages/RetroSynthesis/ProjectRoutes/actions';
import { getRoutesTreeTooltip } from '@Pages/RetroSynthesis/ProjectRoutes/selectors';
import RouteThumbnailsFullTree from '@Pages/RetroSynthesis/RouteTree/components/RouteThumbnailsFullTree';

function RouteThumbnailsFullTreeContainer({
    tree,
    routeName,
    treeTooltip,
    updateTreeThumbnailDetails,
  }) {
  return (
    <RouteThumbnailsFullTree
      tree={tree}
      routeName={routeName}
      onTreeNodeClick={(target, data) => {
        if (treeTooltip && treeTooltip.data && treeTooltip.data.id === data.id) {
          updateTreeThumbnailDetails();
        } else {
          updateTreeThumbnailDetails(target, data);
        }
      }}
    />
  );
}

const mapStateToProps = (state) => ({
  treeTooltip: getRoutesTreeTooltip(state),
});

const mapActionToProps = {
  updateTreeThumbnailDetails: projectRouteTreeTooltipDataChanged,
};

export default connect(mapStateToProps, mapActionToProps)(RouteThumbnailsFullTreeContainer);
